// extracted by mini-css-extract-plugin
export default {"preview":"styles_preview__Z1JSV"};